const ContactInfo = {
  contact_phone: '+966552690995',
  contact_phone_display: '+966 55 269 0995',
  contact_whatsapp: 'https://wa.me/966552690995',
  contact_email: 'sslimfast2000@gmail.com',
  address: 'Saudi Arabia',
  facebook: 'https://www.facebook.com/share/1HDB3CjxTP/?mibextid=wwXIfr',
  instagram: 'https://www.instagram.com/slim_fast_ksa?igsh=NWY1eTR2NXphaWI2&utm_source=qr',
  snapchat: 'https://snapchat.com/t/b5FigAlo',
  tiktok: 'https://www.tiktok.com/@slim.fast90?_r=1&_t=ZS-97VCD8fGoOV',
}

/** Ordered list for footer / social UI */
const socialLinks = [
  {
    id: 'instagram',
    label: 'Instagram',
    href: ContactInfo.instagram,
    icon: 'ph-instagram-logo',
  },
  {
    id: 'facebook',
    label: 'Facebook',
    href: ContactInfo.facebook,
    icon: 'ph-facebook-logo',
  },
  {
    id: 'snapchat',
    label: 'Snapchat',
    href: ContactInfo.snapchat,
    icon: 'ph-snapchat-logo',
  },
  {
    id: 'tiktok',
    label: 'TikTok',
    href: ContactInfo.tiktok,
    icon: 'ph-tiktok-logo',
  },
]

/** External marketplace links (Our Shops) */
const marketplaceLinks = [
  { href: 'https://amazon.com', label: 'Amazon' },
  {
    href: 'https://www.trendyol.sa/farm/slim-fast-package-p-1168025576?boutiqueId=61&merchantId=1291021',
    label: 'Trendyol',
  },
]

const featuredMarketplaces = [
  { id: 1, name: 'Noon', src: 'https://placehold.co/200x100/fcee21/000000?text=Noon', href: 'https://noon.com' },
  { id: 2, name: 'Amazon', src: 'https://placehold.co/200x100/ff9900/ffffff?text=Amazon', href: 'https://amazon.com' },
  {
    id: 3,
    name: 'Trendyol',
    src: 'https://placehold.co/200x100/f27a1a/ffffff?text=Trendyol',
    href: 'https://www.trendyol.sa/farm/slim-fast-package-p-1168025576?boutiqueId=61&merchantId=1291021',
  },
  { id: 4, name: 'Salla', src: 'https://placehold.co/200x100/bbf7d0/166534?text=Salla' },
]

/** How It Works — Slim Fast capsules */
const howItWorksVideoUrl =
  'https://www.tiktok.com/@slim.fast90/video/7653374696850787591?_r=1&_t=ZS-97VCD8fGoOV'
// Magnific Popup iframe needs TikTok's embed URL (watch URLs block iframes)
const howItWorksVideoEmbed = 'https://www.tiktok.com/embed/v2/7653374696850787591'

const howItWorksSteps = [
  {
    step: 'STEP_01',
    title: 'Order Authentically',
    description:
      'Shop Slim Fast capsules from our official store. Every order ships in original packaging with the Golden Guarantee of quality and authenticity.',
    duration: 1000,
  },
  {
    step: 'STEP_02',
    title: 'Take Your Capsule',
    description:
      'Follow the clear usage instructions on the bottle. Take your capsule with water as part of your daily routine — simple, quick, and easy.',
    duration: 1100,
  },
  {
    step: 'STEP_03',
    title: 'Stay Consistent',
    description:
      'Consistency is key. Keep Slim Fast in your wellness routine, track your journey, and reach out anytime via WhatsApp for support.',
    duration: 1200,
  },
]

const teamMembers = [
  { id: 1, name: 'Alice Smith', title: 'Project Manager' },
  { id: 2, name: 'Bob Johnson', title: 'Software Engineer' },
  { id: 3, name: 'Catherine Lee', title: 'UX Designer' },
  { id: 4, name: 'David Brown', title: 'Data Analyst' },
  { id: 5, name: 'Emily Davis', title: 'Marketing Specialist' },
  { id: 6, name: 'Frank Wilson', title: 'Quality Assurance' },
  { id: 7, name: 'Grace Taylor', title: 'Content Strategist' },
  { id: 8, name: 'Henry Moore', title: 'DevOps Engineer' },
]

const server_ip = 'http://localhost:800'

export {
  ContactInfo,
  socialLinks,
  marketplaceLinks,
  featuredMarketplaces,
  howItWorksSteps,
  howItWorksVideoUrl,
  howItWorksVideoEmbed,
  teamMembers,
  server_ip,
}
